import Slogan from "./Slogan/Slogan"
import Relationship from "./Relationship/Relationship"

function Footer() {
  return (
    <>
      <footer className="w-full h-96 bg-neutral-700" dir="rtl">
        <div className="Container flex h-full">
          <Slogan />
          <Relationship />
        </div>
      </footer>
    </>
  );
}

export default Footer;